import { createStore } from '@stencil/store';
import { collection, orderBy, query } from 'firebase/firestore';
import { FirebaseService } from '../utils/firebase';
import { collectionData } from 'rxfire/firestore';
import { EMPTY, Subscription, catchError, skipWhile } from 'rxjs';

import { settings } from './settings.store';

import { Discount } from '@artask/tambr-models/models/discount.model';


interface State {
  loading: boolean;
  loaded: boolean;
  discounts: Discount[];
  subscription: Subscription;
}

const { state } = createStore<State>({
  loading: null,
  loaded: null,
  discounts: null,
  subscription: null,
});


export function setDiscountsListener() {
  try { 
    state.loading = true;
    state.subscription = collectionData( 
      query(
        collection( FirebaseService.firestore, `businesses/${ settings.businessId }/discounts` ),
        orderBy( 'order', 'asc' )
      ), { idField: 'id' } 
    ).pipe(
      skipWhile( () => settings.appCheckFailed ),
      catchError( error => {
        console.error( 'Error fetching discounts:', error );
        return EMPTY;
      })
    ).subscribe( ( discounts: Discount[] ) => {
      console.log('setDiscountsListener', discounts);
      state.discounts = discounts;
      state.loaded = true;
      state.loading = false;
    });
  } catch (e) {
    console.error('loadDiscounts', e);
    state.loading = false;
  }
}

function stopDiscountListener() {
  if ( state.subscription ) state.subscription.unsubscribe(); 
}


export { 
  state as discountState,
  stopDiscountListener
};